export default {"LABEL":"Font OT 基础图标","DESC":"2O3T-UI 基础图标库，我们还在持续补充中。","COMPONENTS":{"__markdown":true}}